export const DEFAULT_SETTINGS = {
  propertyName: "Hotel Băile Felix",
  currency: "RON",
  accommodationVatRate: 11,
  touristTaxRate: 1,
  commissionRate: 15,
  commissionVatRate: 21,
  commissionVatRecoverable: 100,
  commissionBasis: "includingVat",
  stackingMode: "stack",
  promotionBehaviorVersion: 2,
  calculatorMode: "clientPrice",
  defaultAdults: 2,
  defaultChildren: 0,
  checkInTime: "15:00",
  checkOutTime: "11:00"
};

export const DEFAULT_ROOMS = [
  {
    id: "room-101",
    name: "Felix Double",
    code: "101",
    type: "Double",
    capacity: 2,
    targetNet: 466.75,
    status: "active",
    color: "#6558d3",
    notes: "King bed · balcony"
  },
  {
    id: "room-102",
    name: "Lotus Twin",
    code: "102",
    type: "Twin",
    capacity: 2,
    targetNet: 440,
    status: "active",
    color: "#0f8f83",
    notes: "Two single beds"
  },
  {
    id: "room-201",
    name: "Thermal Suite",
    code: "201",
    type: "Suite",
    capacity: 4,
    targetNet: 680,
    status: "active",
    color: "#dc7a4b",
    notes: "Living room · family friendly"
  }
];

export const DEFAULT_PROMOTIONS = [
  {
    id: "promo-genius",
    name: "Genius",
    discount: 10,
    active: true,
    channel: "Booking.com",
    notes: "Logged-in eligible guests"
  },
  {
    id: "promo-mobile",
    name: "Mobile rate",
    discount: 10,
    active: false,
    channel: "Booking.com",
    notes: "App and mobile browser"
  },
  {
    id: "promo-direct",
    name: "Direct booking",
    discount: 5,
    active: false,
    channel: "Direct",
    notes: "Optional direct-booking discount"
  }
];

export const DEFAULT_TARIFFS = [
  {
    id: "tariff-standard",
    name: "Standard 2026",
    roomId: "",
    startDate: "2026-01-01",
    endDate: "2026-12-31",
    targetNet: 466.75,
    weekendAdjustment: 10,
    minStay: 1,
    active: true
  }
];

export const DEFAULT_RESERVATIONS = [];
